module.exports = "<div class=gmc-dropdown-menu><span class=gmc-dropdown-menu__toggler ng-click=$ctrl.toggle()><i class=\"material-icons gmc-dropdown-menu__icon\" ng-class={active:$ctrl.isActive}>{{::$ctrl.icon}}</i></span><div class=gmc-dropdown-menu__list-container ng-show=$ctrl.isActive ng-class=$ctrl.position ng-transclude></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-dropdown-menu/gmc-dropdown-menu.component.html
// module id = 551
// module chunks = 31